export default __webpack_public_path__ + "static/media/registry.86713058.svg";